import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Button, Input, Form,FormInstance, Steps, Upload} from "antd";

import { useTranslation } from "react-i18next";
import { sendEmailCode,emailRegister } from "../axios/api.account"
import "./pages.scss";
import { FileFilled, UploadOutlined } from "@ant-design/icons";

export function EmailRegister() {
    const [step, setStep] = useState<number>(0);
    const stepRef = useRef(step);
    stepRef.current = step;
    const [req, setReq] = useState<any>({});
    const [isSent, setIsSent] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [countdown, setCountdown] = useState(60); 
    const countRef = useRef(countdown);
    countRef.current = countdown;

    const { t } = useTranslation();
    const formRef = React.createRef<FormInstance>();
    const formStepRef = React.createRef<FormInstance>();
    
    const [fileList, setFileList] = useState<any[]>(); 
    const sendCode = () => {
      // var email = formRef.current?.getFieldValue('email');
      // var emailError = formRef.current?.getFieldError('email');
      formRef.current?.validateFields(['email']).then(res=>{
          console.log(res.email);
          setIsSent(true);
          startCountdown();
          sendEmailCode(res.email,true).then(() => {  
            
          },()=>{
            setIsSent(false);
          })
      });
      // var isError = emailError != undefined && emailError?.length > 0 ? true: false; 
      // if(email && !isError)
      // {
      //   console.log('in');
      //   setIsSent(true);  
      //   sendEmailCode(email,true).then(() => {  
      //     startCountdown();
      //   },()=>{
      //     setIsSent(false);
      //   })
      // }
    }; 

    const startCountdown = () => {  
      let intervalId = setInterval(() => {  
        if (countRef.current > 0) {  
          setCountdown(countdown=> countdown - 1);  
        } else {
          setIsSent(false);  
          clearInterval(intervalId);  
          setCountdown(countdown=> countdown + 60);  
        }  
      }, 1000);  

      // 在组件卸载时清除倒计时，避免内存泄漏  
      return () => clearInterval(intervalId);  
    };  

    function oneStep(){
      formRef?.current?.validateFields().then(res=>{
        setStep(step=> step+1);
        setReq({email: res.email, code: res.code, password: res.password});
      })
    }
    function twoStep(){
      formStepRef?.current?.validateFields().then(res=>{
        setIsSubmit(true);
        console.log(res);
        var reqData = {email: req.email, code: req.code, password: req.password, companyFile: res?.companyFile[0].originFileObj, company: res.company, name: res.user, phone: res.phone, description: res.description ?? ''};
        emailRegister(reqData).then(() => {  
          setStep(step=> step+1);
        })
        .finally(
          () => { setIsSubmit(false); }
        );        
      })
    }

    const validateMinLength = (rule:any, value:any) => {  
      if (!value || value.length < 8) {  
        return Promise.reject(new Error('密码长度不能小于8'));  
      }  
      return Promise.resolve();  
    }; 
    const uploadFile = (res: any) => {
      console.log(res);
      setFileList(res.fileList);
    };

      // 自定义验证规则 - 检查是否已上传文件
    const validateUpload = (_: any, value: any) => {
      if (!value || value.fileList.length === 0) {
        return Promise.reject(new Error('请上传营业执照!'));
      }
      return Promise.resolve();
    };

    const customRequest = (options: any) => {
      // 这里不执行实际的上传，只是模拟成功
      const { onSuccess, onError, file, onProgress } = options;
      onSuccess();
    };
    // useEffect(() => {  
    //   return () => {  
    //     if (isSent) {  
    //       console.log('isSent..',isSent);
    //       startCountdown();  
    //     }  
    //   };  
    // }, [isSent]);

    return (
      <div className="login-container" style={{backgroundImage: "url(images/bg.png)"}}>  
        <div className="logo-container">  
          {/* 这里应该放置TAPD的Logo */}  
          <h1> {t("未瓴移动设备管理平台")}</h1>
        </div>
        <Steps
          current={step}
          className="mt-4"
          style={{width:'60%'}}
          items={[
            {
              title: t('注册账号')
            },
            {
              title: t('完善信息')
            },
            {
              title: t('注册完成')
            },
          ]}
        />
        <div className="mx-auto" style={{ marginTop: "50px",width:'40%' }}>
          <div style={{ }}>
            {stepRef.current === 0 && (
              <Form
              ref={formRef}
              name="basic"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 16 }}
              //style={{ maxWidth: 600 }}
              autoComplete="off"
              >
                <Form.Item
                  label={t("邮箱")}
                  name="email"
                  rules={[
                    { 
                      required: true, 
                      message: t("请输入邮箱") 
                    },
                    {
                      type: 'email',
                      //pattern: new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"),
                      message: t('邮箱格式错误')
                    }
                  ]}
                >
                <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                  label={t("验证码")}
                  name="code"
                  rules={[{ required: true, message: t('请输入验证码') }]}
                >
                  <Row>
                    <Col span={12}>
                      <Input />
                    </Col>
                    <Col span={12}>
                      <Button disabled={isSent} onClick={isSent ? undefined : sendCode}>  
                        {isSent ? t('重新发送') + `(${countdown}s)` : t('发送验证码')}  
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item
                  label={t("密码")}
                  name="password"
                  rules={[
                    { 
                        required: true,
                        message: t('请输入密码')
                    },
                    {
                        // pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$'), ，。？！（）【】《》
                        pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[~`·!@#$%^&*()<>?,.:;_+/、，。：；？！（）【】《》-]).{8,}$'),
                        message: t('密码必须包含大小写字母和特殊字符，且长度至少为8'),
                        //message: 'Password must contain at least one lowercase, one uppercase, and one special character, and be at least 8 characters long.',
                    }]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name="confirm"
                  label={t("密码确认")}
                  dependencies={['password']}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: '请确认您的密码!',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        // return Promise.reject(new Error('The two passwords that you entered do not match!'));
                        return Promise.reject(new Error('两次输入的密码不匹配!'));
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                  <Button type="primary" onClick={() => { oneStep(); } } className="login-form-button" htmlType="submit">
                    {t("下一步")}
                  </Button>
                </Form.Item>
              </Form>
            )}
            {stepRef.current === 1 && (
              <Form
              ref={formStepRef}
              name="basic"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 16 }}
              //style={{ maxWidth: 600 }}
              autoComplete="off"
              >
                <Form.Item
                  label={t("公司名称")}
                  name="company"
                  rules={[{ required: true, message: '请输入公司名称!' }]}
                >
                  <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                  label="联系人"
                  name="user"
                  rules={[{ required: true, message: '请输入联系人!' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label={t("手机号码")}
                  name="phone"
                  rules={[
                    { 
                      required: true, 
                      message: '请输入手机号!' 
                    },
                    {
                      pattern: /^1[3-9]\d{9}$/,
                      message: '手机号格式错误!',
                    }
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="companyFile"
                  label={t("营业执照")}
                  extra={t("支持pkg、dmg格式，文件不大于1000MB")}
                  valuePropName="fileList"
                  getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
                  rules={[
                    {
                      required: true,
                      message: '请上传营业执照!',
                    },
                    // {
                    //   validator: validateUpload
                    // }
                  ]}
                >
                  <Upload
                    accept=".pdf,.jpg,.png"
                    listType="text"
                    fileList={fileList}
                    customRequest={customRequest}
                    onChange={uploadFile}
                    onRemove={() => setFileList([])}
                    showUploadList={true}
                    maxCount={1}
                    >
                    <Button icon={<UploadOutlined />}>+ {t("点击上传")} </Button>
                  </Upload>
                </Form.Item>
                <Form.Item
                  label={t("备注")}
                  name="description"
                  rules={[{ required: false }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                  <Button type="primary" disabled={isSubmit} onClick={isSubmit ? undefined : twoStep} className="login-form-button" htmlType="submit">
                    {t("下一步")}
                  </Button>
                </Form.Item>
              </Form>
            )}
            {stepRef.current === 2 &&(
              <><Row>
                  <Col span={18} offset={6}>
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                      <p>已完成注册，我们会在三个工作日内联系您</p>
                      <p>审核通过后即可体验，谢谢</p>
                    </span>
                  </Col>
                </Row>
                <Row style={{ marginTop: "30px" }}>
                    <Col span={18} offset={8}>
                      <Button type="primary" onClick={()=> { window.location.href= '/'}} className="login-form-button" style={{ width: "60%" }}>回到首页</Button>
                    </Col>
                </Row>
              </>
            )}
          </div>
        </div>
      </div> 
    )
}